/**
 * Normalize shop product names for display (DB names may omit color variant).
 */
export function getProductDisplayName(name) {
  if (!name || typeof name !== 'string') {
    return name;
  }

  const trimmed = name.trim();
  const lower = trimmed.toLowerCase();

  const isProTempHumiditySensor =
    lower.includes('temperature') &&
    lower.includes('humidity') &&
    lower.includes('sensor') &&
    (lower.includes('chillverify') || lower.includes('pro'));

  const hasColorSuffix =
    /[-\s](black|white)\s*$/i.test(trimmed) ||
    lower.includes('-black') ||
    lower.includes('-white');

  if (isProTempHumiditySensor && !hasColorSuffix) {
    return `${trimmed} - Black`;
  }

  return trimmed;
}
